import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { UserUpload } from '../../lib/types/UserUpload'

type Upload = {
  id: number
  name: string
  description: string
  currency_id: number
  end_currency_id: number
  transaction_type_id: number
  gain_strategy: number
}

export const useGetUploadById = ({
  upload_id,
}: {
  upload_id: number
}): UseQueryResult<Upload, Error> => {
  return useQuery(
    ['uploads', upload_id],
    () =>
      request({
        url: `/uploads/${upload_id}`,
        method: 'GET',
      }),
    { enabled: !!upload_id },
  )
}
